import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleCareerMenu } from '../../../store/actionCreators/career';

const CareerTitle = ({ selectedGame, selectedClub }) => {
    const dispatch = useDispatch();

    const openMenu = useCallback(() => {
        dispatch(toggleCareerMenu());
    });

    return (
        <div className={"careerTitle"}>
            <div className={"data"}>
                <button onClick={() => console.log('')} >
                </button>
                <span>EXL</span>
            </div>
            {
                (selectedGame.map(game => game.label) && selectedClub.clubName) ? 
                (`${selectedClub.clubName}: ${selectedGame.map((game, index) => game.label)}`) : ('')
            }
            <div className={"menu"}>
                <button className={'careerOpener'} onClick={() => openMenu()}>
                    <div></div>
                    <div></div>
                    <div></div>
                </button>
            </div>
        </div>
    )
}

export default CareerTitle;